<div class="p-2" style="height:100%;align-content:center;">
  <div style="display: flex; padding-bottom: 10px;" class="justify-content-center">
    <input name="SPID" placeholder="Part Number" class="smallInput smallMargin align-content-center" style="width:80%;" [(ngModel)]="CurrentSPDetail.Item" />
  </div>
  <div class="row-no-margin justify-content-center">
    <!--buttons-->
    <button class="blue" (click)="AddSPLine()">Save</button>&nbsp;
    <button class="blue" (click)="CloseWindow()">Close</button>
  </div>
</div>
